import React from 'react';
import { UserListsCarousel as UsersProductList } from '@thd-olt-component-react/user-lists';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
export var ProductList = function () { return (React.createElement(ErrorBoundary, { name: "product-list" },
    React.createElement(UsersProductList, null))); };
